import * as React from 'react';
import { ModalProps,  ModalSize } from './Modal.types'

export const Modal = ({
    children,
    show,
    onChange,
    size
}: ModalProps) => {

    if(!size) size = ModalSize.Large;

    const [ showState, setShowState ] = React.useState(show);

    React.useEffect(() => {
        setShowState(show);
    }, [show]);

    return (
        <div 
            className={`
                cb-modal-wrapper
                ${showState ? `cb-modal-wrapper--show` : '' }
                cb-modal-wrapper--size--${size}
            `}
        > 
            <div 
                className="cb-backdrop"
                onClick={() => onChange && onChange(false)}
            />
            <div className="cb-modal">
                <button
                    className="cb-modal__close fa-close fa-solid"
                    onClick={() => onChange && onChange(false)}
                />
                
                {children}
            </div>
        </div>
        
    )
};